export default "__VITE_ASSET__CaXzB6yk__"